import React from 'react';
import { useAuth } from '../auth';
import { LoginPage } from '../LoginPage';
import { useNavigate } from 'react-router-dom';
import ProgressTabs from '../components/ProgressTabs';
import SweatTextTitle from '../steps/SweatTextTitle';
import RemindersInfo from './RemindersInfo';


import '../BasicReminder.css';

const Step1 = () => {
  const { user } = useAuth();
  const navigate = useNavigate();

  return (
    <div className="reminder-container fogged-card">
      <SweatTextTitle />
      <RemindersInfo />


      <ProgressTabs currentStep={0} />


      <h2 style={{ marginTop: 32, marginBottom: 10 }}>
        Step 1: Create Trainer Account using Google Login
        </h2>

      { user && user.role && user.role.includes('client')  && (
        <p>
          It seems like you are logged in as a client. 
          <br />
          <br />
          This setup is actually for trainers, sorry!
          <br />
          <br />
          Check out the client reminder dashboard <a href="/tools/reminders/dashboard">here</a> {' '}
          to adjust reminder settings.
          <br />
          <br />
          Please ask your trainer to set up reminders for you.
        </p>
      ) }

      {user && user.role && user.role.includes('trainer') && 
        <p>Looks like you are already logged in, great! Proceed to next step.</p>
      }
      {user && user.role && user.role.includes('trainer') && 
        <div>
          Existing trainers can {' '}
          <a style={{cursor: 
            'pointer', 
              color: 'blue',
              textDecoration: 'underline'
          }} onClick={() => navigate('/tools/reminders/dashboard')} >
            go to their dashboard.
          </a>
        </div>
      }


        {user && user.role && user.role.includes('trainer') && 
              <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '2rem' }}>
                <button className="ptc-button" onClick={() => navigate('/tools/reminders/step-trainer-phone')} style={{ padding: '1rem 2rem', fontSize: '1rem' }}>
                  Next Step
                </button>
              </div>
        }


        {!user && (
          <>

        <div style={{marginBottom: 16, fontSize: '0.95rem'}}>
          By logging in, you agree to our{' '}
          <a href="/terms">Terms of Service</a> and{' '}
          <a href="/privacy">Privacy Policy</a>.
        </div>
        <LoginPage onLogin={() => {
          // After login, redirect to the same page to continue setup
          window.location.href = '/tools/reminders/step-trainer-phone';
            }} />
          </>
        )}
    </div>
  );
};

export default Step1;




